import { Component, ElementRef, ViewChild } from '@angular/core';
import { DiagramComponent } from '../diagram/diagram.component';

@Component({
  selector: 'app-show-diagram',
  templateUrl: './show-diagram.component.html',
  styleUrl: './show-diagram.component.css'
})
export class ShowDiagramComponent {
  // @ViewChild(DiagramComponent) diagramComponent: DiagramComponent;
  // @ViewChild("fileInput") fileInput: ElementRef;

  // diagramUrl =
  // "https://cdn.statically.io/gh/AlvaroG1016/prueba-bpmn/main/newDiagram.bpmn";
  // importError?: Error;
  // archivoTabActivo: string | null = null; // Inicialmente, ningún menú está abierto


  // handleImported(event) {
  //   const { type, error, warnings } = event;
  //   if (type === "success") {
  //     console.log(`Rendered diagram (%s warnings)`, warnings.length);
  //   }

  //   if (type === "error") {
  //     console.error("Failed to render diagram", error);
  //   }

  //   this.importError = error;
  // }



  // //LOgica Menu
  // toggleTab(tab: string) {
  //   if (this.archivoTabActivo === tab) {
  //     this.archivoTabActivo = null; // Si la misma pestaña se hace clic de nuevo, cierra el menú
  //   } else {
  //     this.archivoTabActivo = tab; // Si se hace clic en una nueva pestaña, abre su menú y cierra el otro
  //   }
  // }

  // activateExportArtifacts() {
    
  //   if (this.diagramComponent) {
  //     this.diagramComponent.exportArtifacts();
  //   } else {
  //     console.error("DiagramComponent no está disponible.");
  //   }
  // }

  // openFileInput() {
  //   this.fileInput.nativeElement.click();
  // }

  // onFileSelected(event: any) {
  //   const file: File = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       const xml: string = reader.result.toString();
  //       this.diagramComponent.importDiagram(xml);
  //     };
  //     reader.readAsText(file);
  //   }
  // }

}
